import React, { useEffect, useMemo, useState } from 'react';
import { CONFIGS_URL, getFetchRequest, postFetchRequest } from '../store/requests';
import { makeUrl, errorCallback } from '../constant';
import { CheckIconThin } from '../appearence/icons/check_icon_thin';

const CONFIG_TELEGRAM_ENABLED = 'aurora-telegram-enabled';
const CONFIG_TELEGRAM_BOT_TOKEN = 'aurora-telegram-bot-token';
const CONFIG_TELEGRAM_CHAT_IDS = 'aurora-telegram-chat-ids';

const NotificationsTab = ({ isCollapsed }) => {
    const [configsList, setConfigsList] = useState([]);

    useEffect(() => {
        getFetchRequest(makeUrl([CONFIGS_URL]), (result) => setConfigsList(result || []), errorCallback);
    }, []);

    const getConfig = useMemo(() => {
        const map = new Map();
        (configsList || []).forEach((c) => {
            if (c && c.configName) map.set(c.configName, c);
        });
        return (name) => map.get(name);
    }, [configsList]);

    const updateConfig = (cfg, next) => {
        if (!cfg || !cfg.id) return;
        // Оптимистично обновляем UI
        setConfigsList((prev) => (prev || []).map((c) => (c.id === cfg.id ? { ...c, ...next } : c)));
        postFetchRequest(
            makeUrl([CONFIGS_URL, cfg.id, '/']),
            { configValue: next.configValue ?? cfg.configValue ?? null, isActive: typeof next.isActive === 'boolean' ? next.isActive : cfg.isActive },
            () => {},
            errorCallback,
            true,
        );
    };

    const enabledCfg = getConfig(CONFIG_TELEGRAM_ENABLED);
    const tokenCfg = getConfig(CONFIG_TELEGRAM_BOT_TOKEN);
    const chatIdsCfg = getConfig(CONFIG_TELEGRAM_CHAT_IDS);

    return (
        <section className={`workspace ${isCollapsed === null ? '' : isCollapsed ? 'workspace_collapsed' : 'workspace_full-width'} config__page`}>
            <h1 className="config__title">Уведомления</h1>
            <ul className="config__list">
                <li className="config__item">
                    <p className="config__subtitle">AURORA_TELEGRAM_ENABLED</p>
                    {enabledCfg ? (
                        <label className="config__label">
                            <input
                                type="checkbox"
                                className="config__checkbox"
                                checked={Boolean(enabledCfg.isActive)}
                                onChange={(e) => updateConfig(enabledCfg, { isActive: e.target.checked })}
                            />
                            <CheckIconThin nameOfClass="config__checkbox-icon" />
                        </label>
                    ) : (
                        <p className="config__subtitle">Конфиг не найден в app_configs</p>
                    )}
                </li>

                <li className="config__item">
                    <p className="config__subtitle">AURORA_TELEGRAM_BOT_TOKEN</p>
                    {tokenCfg ? (
                        <input
                            className="config__input"
                            type="password"
                            value={tokenCfg.configValue || ''}
                            onChange={(e) => updateConfig(tokenCfg, { configValue: e.target.value, isActive: true })}
                        />
                    ) : (
                        <p className="config__subtitle">Конфиг не найден в app_configs</p>
                    )}
                </li>

                <li className="config__item">
                    <p className="config__subtitle">AURORA_TELEGRAM_CHAT_IDS</p>
                    {chatIdsCfg ? (
                        <input
                            className="config__input"
                            type="text"
                            placeholder="1014385024, 123456789"
                            value={chatIdsCfg.configValue || ''}
                            onChange={(e) => updateConfig(chatIdsCfg, { configValue: e.target.value, isActive: true })}
                        />
                    ) : (
                        <p className="config__subtitle">Конфиг не найден в app_configs</p>
                    )}
                </li>
            </ul>
        </section>
    );
};

export default NotificationsTab;

